module.exports = __webpack_public_path__ + "img/happyImage.7b89a771.png";